"use client";
import { EventEmitter } from 'events';
import { getUuid } from '@sravni/react-utils';
import { NOTIFICATION_TIMEOUT, NOTIFICATION_STATUSES } from '../types/Notifications.types.js';

class NotificationManager extends EventEmitter {
    notifications = [];
    constructor() {
        super();
    }
    create({ type = 'info', title, subtitle, message, timeout, closable }) {
        const opts = {
            id: getUuid(),
            type,
            title,
            subtitle,
            message,
            closable,
        };
        this.notifications.unshift(opts);
        this.emitChange();
        setTimeout(() => {
            this.remove(opts.id);
        }, timeout);
    }
    show(props) {
        const { timeout = NOTIFICATION_TIMEOUT, type = NOTIFICATION_STATUSES.INFO, closable = true, ...restProps } = props;
        this.create({ timeout, type, closable, ...restProps });
    }
    remove(id) {
        this.notifications = this.notifications.filter((n) => id !== n.id);
        this.emitChange();
    }
    emitChange() {
        this.emit('change', [...this.notifications]);
    }
    addChangeListener(callback) {
        this.addListener('change', callback);
    }
    removeChangeListener(callback) {
        this.removeListener('change', callback);
    }
}
var NotificationManager$1 = new NotificationManager();

export { NotificationManager$1 as default };
//# sourceMappingURL=NotificationManager.js.map
